<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="stop-sign"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      height="normal"
      [mat-dialog-close]="true"
    >
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_SUBMIT" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      mat-dialog-close
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
    >
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
